import * as yup from 'yup';
import ValidationUtil from "../Utils/ValidationUtil";

class AwardValidation {

    static async validate(form) {
        try {

            let objectValidade = {
                value_type: yup
                    .number(ValidationUtil.MSG_FIELD_NUMBER)
                    .integer(ValidationUtil.MSG_INTERGER)
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
                value: yup
                    .string()
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
                value_points: yup
                    .number(ValidationUtil.MSG_FIELD_NUMBER)
                    .max(999999999, ValidationUtil.MSG_FIELD_MAX_NUMBER)
                    .typeError(ValidationUtil.MSG_FIELD_NUMBER)
                    .positive(ValidationUtil.MSG_FIELD_POSITIVE)
                    .integer(ValidationUtil.MSG_INTERGER)
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
                description: yup
                    .string()
                    .max(255, ValidationUtil.MSG_FIELD_MAX)
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
                start_validity: yup
                    .string()
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
                end_validity: yup
                    .date()
                    .when(
                        'start_validity',
                        (startDate, schema) => (startDate && schema.min(
                            startDate,
                            ValidationUtil.MSG_DATE_RANGE_END
                        )),
                    ).required(ValidationUtil.MSG_FIELD_REQUIRED),
                fidelity_programs_uuid: yup
                    .string()
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
            };

            if (Array.isArray(form.images) && form.image === undefined) {
                delete objectValidade.image;
            }

            if (form.withoutValidDate === true) {
                delete objectValidade.start_validity;
                delete objectValidade.end_validity;
            }

            let validate = yup.object().shape(objectValidade);

            validate.validateSync(form, {abortEarly: false})

            return true;

        } catch (e) {
            let erros = [];
            e.inner.forEach(function (value, index) {
                erros[value.path] = value.message;
            });

            return erros;
        }
    }

}

export default AwardValidation;